import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {
  BadgeContainer,
  CategorizedTasksContainer,
  ContentContainer,
  CustomSlider,
  DateGroupHeader,
  HomePageContainer,
  ItemsWrapper,
  RecentlyFilledItemsContainer,
  RecentlyFilledItemsList,
  SectionTitle,
  SliderContainer,
  TaskListViewContainer,
  TaskStackContainer,
  TaskSummeryContainer,
} from './styles';
import React, { useEffect, useRef, useState } from 'react';
import {
  black,
  blue,
  green,
  orange,
  purple,
  red,
} from '../../utils/style/colors';
import { useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../store/store';
import { getAllRecentlyFilledSurveys } from '../../api/ManApi';
import { ITask } from '../../store/tasks/tasksType';
import { navigate, RouteComponentProps } from '@reach/router';
import UserMixpanel from '../../utils/mixpanel/MixpanelClass';
import { isANumber } from '../../utils/number';
import { useTranslation } from 'react-i18next';
import LoadingCircleIndicator from '../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import { getCompanyHandler } from '../../store/companies/companiesSlice';
import { ICompany } from '../../store/companies/companiesTypes';
import { searchTasks, updateTask } from '../../store/tasks/tasksSlice';
import { ISearchParams } from '../../store/entity/types';
import TaskListView from '../../components/TaskListView/TaskListView';
import { display } from '../../components/ErrorView/ErrorDialog';
import { ISurveyItem } from '../../store/survey/surveyTypes';
import Slider, { Settings } from 'react-slick';
import LocalIcon from '../../ui/LocalIcon';
import moment from 'moment-jalaali';
import { useTour } from '@reactour/tour';
import TaskMentionContainer from '../../components/TaskMentionContainer/TaskMentionContainer';
import ButtonGroup from '../../components/ButtonGroup/ButtonGroup';
import { convertDigitToProperFormat } from '../../utils/number';
import { addTourStep } from '../../context/Tour/TourWrapper';
// import SurveyFormModal from 'components/FileManager/SurveyForm/SurveyFormModal';
// import { SINGLE_DAY_BASE_ON_TIME_STAMP } from 'components/FileManager/ItemsViewer/Survey/SurveyResponseViewer/ResponseItem';
// import { setAddOrUpdateUserFlag } from 'store/thisUser/thisUserSlice';

export const handleNextSeasonTimestamp = (): number => {
  const now = new Date();
  const currentJalali = moment(now);
  const currentMonth = currentJalali.jMonth() + 1;

  let nextSeasonMonth: number;
  let nextSeasonYear: number = currentJalali.jYear();

  if (currentMonth >= 1 && currentMonth <= 3) {
    nextSeasonMonth = 4;
  } else if (currentMonth >= 4 && currentMonth <= 6) {
    nextSeasonMonth = 7;
  } else if (currentMonth >= 7 && currentMonth <= 9) {
    nextSeasonMonth = 10;
  } else {
    nextSeasonMonth = 1;
    nextSeasonYear += 1;
  }

  const nextSeasonJalali = moment(
    `${nextSeasonYear}/${String(nextSeasonMonth).padStart(2, '0')}/01`,
    'jYYYY/jMM/jDD'
  );

  const nextSeasonDate = nextSeasonJalali.toDate();
  nextSeasonDate.setHours(0, 0, 0, 0);

  return nextSeasonDate.getTime();
};

interface IHomePageProps {
  companyId?: string | number;
  children?: React.ReactNode;
}

type IComponentProps = IHomePageProps & RouteComponentProps;

type TLoading = 'fetching' | '';

const CURRENT_DATE_FORMAT = 'YYYY-MM-DD';
const TOMMOROW_GAP = 24 * 60 * 60 * 1000;
const DAY_AFTER_TOMORROW_GAP = 2 * 24 * 60 * 60 * 1000;

const CompanyHomePage: React.FC<IComponentProps> = ({
  companyId,
  children,
}) => {
  const { t } = useTranslation('general');

  const componentTour = [
    {
      selector: '.companyHomepage-cards',
      content: t('cardsTour'),
      category: 'companyHomepage-cards',
    },
    {
      selector: '.companyHomepage-taskList',
      content: t('taskListTour'),
      category: 'companyHomepage-taskList',
    },
    {
      selector: '.companyHomepage-slider',
      content: t('sliderTour'),
      category: 'companyHomepage-slider',
    },
  ];

  const state = useSelector((state: RootState) => state);
  const thisUser = state.thisUser;
  const occurentContainerRef = useRef<HTMLDivElement>(null);
  const [occurentContainerWidth, setOccurentContainerWidth] =
    useState<number>(0);
  const { setSteps } = useTour();

  const [assigneedTasksIdList, setAssigneedTasksIdList] = useState<number[]>(
    []
  );
  const assigneedTasks = useSelector((state: RootState) =>
    Object.values(state.tasks.data).filter((task: ITask) =>
      assigneedTasksIdList.includes(task.id)
    )
  );
  const [company, setCompany] = useState<ICompany | null>(() => {
    return state.companies.data?.[Number(companyId)] || null;
  });
  const [selectedTemplateId, _] = useState<number | 'all'>('all');
  const [taskFilter, setTaskFilter] = useState<'all' | 'incomplete'>('all');
  const [recentSurveyItems, setRecentSurveyItems] = useState<Array<
    Array<ISurveyItem>
  > | null>(null);
  const [allItems, setAllItems] = useState<ISurveyItem[] | null>(null);

  const [loading, setLoading] = useState<{ [key: number]: TLoading }>({
    1: '',
    2: '',
  });
  const [windowWidth, setWidnowWidth] = useState<number>(window.innerWidth);
  const [chunkSize, setChunkSize] = useState<number>(() =>
    windowWidth > 1400 ? 10 : windowWidth > 900 ? 5 : windowWidth > 600 ? 6 : 5
  );
  // const hasPDP = (company?.pdpPanels?.length || 0) > 0;
  // const surveyModalStatus = state.thisUser.userFlags?.['homepage']?.find(
  //   (el) => el.flagName === 'surveyPDP'
  // )?.flagValue;

  // PDP Survey Modal
  // const [surveyModalIsOpen, setSurveyModalIsOpen] = useState<boolean>(() => {
  //   const currentDate = new Date().getTime();
  //   if (!hasPDP) return false;
  //   return surveyModalStatus === 'true'
  //     ? false
  //     : !surveyModalStatus
  //       ? true
  //       : currentDate > Number(surveyModalStatus)
  //         ? true
  //         : false;
  // });

  // const setNextSeasonFlag = () => {
  //   const nextSeason = handleNextSeasonTimestamp();
  //   appDispatch(
  //     setAddOrUpdateUserFlag({
  //       flagName: 'surveyPDP',
  //       flagValue: `${nextSeason}`,
  //       flagGroup: 'homepage',
  //     })
  //   );
  // };

  // const handleNextFiveDayFlag = () => {
  //   const now = new Date();
  //   now.setHours(0, 0, 0, 0);
  //   const nextFiveDay = new Date(
  //     now.getTime() + 5 * SINGLE_DAY_BASE_ON_TIME_STAMP
  //   ).getTime();
  //   appDispatch(
  //     setAddOrUpdateUserFlag({
  //       flagName: 'surveyPDP',
  //       flagValue: `${nextFiveDay}`,
  //       flagGroup: 'homepage',
  //     })
  //   );
  // };

  // const handleDismissSurveyModal = () => {
  //   setSurveyModalIsOpen(false);
  //   if (!surveyModalStatus) {
  //     // set for next five day
  //     handleNextFiveDayFlag();
  //   } else {
  //     // set for next season
  //     setNextSeasonFlag();
  //   }
  // };

  // const handleCloseSurveyModal = () => {
  //   setSurveyModalIsOpen(false);
  //   setNextSeasonFlag();
  // };

  const sliderRef = useRef<Slider | null>(null);
  const settings: Settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    pauseOnHover: true,
  };

  function chunkArray<T>(arr: T[]): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      chunks.push(arr.slice(i, i + chunkSize));
    }
    return chunks;
  }

  const handleGetAllRecentlyFilledSurveys = async () => {
    setLoading((prevState) => ({ ...prevState, [2]: 'fetching' }));
    const surveyItemRes = await getAllRecentlyFilledSurveys(
      state,
      companyId!,
      20
    );
    setAllItems(surveyItemRes.data);
    const chunkedArray = chunkArray([...surveyItemRes.data]);
    setRecentSurveyItems([...chunkedArray]);
    setLoading((prevState) => ({ ...prevState, [2]: '' }));
  };

  const handleClickOnTask = (task: ITask, _: any) => {
    const mx = UserMixpanel.getInstance();
    mx.visitedTasksCountHandler();
    if (isANumber(task.id)) {
      mx.handleSetVisitedTaskCountByTemplates(task.taskName);
    }
    let url = `/t/${companyId}/home/editor`;
    if (task.id) {
      url = `${url}/${task.id}/info`;
    }
    navigate(url);
  };

  const handleUpdateTask = (task: ITask) => {
    appDispatch(updateTask({ task })).catch((err: any) => {
      display(err);
    });
  };

  // const handleChangeTemplate =
  //   (templateId: 'all' | number, _: { [key: string]: string }) => () => {
  //     setSelectedTemplateId(templateId);
  //   };

  useEffect(() => {
    if (companyId && !company) {
      appDispatch(getCompanyHandler({ companyId: Number(companyId) })).then(
        (res: any) => {
          setCompany(res.company);
        }
      );
    }

    // current Date
    // const currentDate = new Date().getTime();
    // last date: 7 days after current Date
    // const lastDate = currentDate + 7 * 24 * 60 * 60 * 1000;
    const params: ISearchParams = {
      from: 0,
      count: 20,
      companyId: Number(companyId),
      assigneeId: Number(state.thisUser.userId),
      parentId: null,
      dateOffsetFromNow: 7 * 24 * 60 * 60 * 1000,
      dateOffsetToNow: 7 * 24 * 60 * 60 * 1000,
    };

    setLoading((prevState) => ({ ...prevState, [1]: 'fetching' }));
    appDispatch(
      searchTasks({
        params,
      })
    )
      .then((res: any) => {
        setAssigneedTasksIdList(res.tasks.map((task: ITask) => task.id));
      })
      .finally(() => {
        setLoading((prevState) => ({ ...prevState, [1]: '' }));
      });
  }, []);

  useEffect(() => {
    handleGetAllRecentlyFilledSurveys();
  }, [company]);

  useEffect(() => {
    const handleChangeWindow = () => {
      setWidnowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleChangeWindow);

    return () => window.removeEventListener('resize', handleChangeWindow);
  }, []);

  useEffect(() => {
    setOccurentContainerWidth(occurentContainerRef.current?.clientWidth || 0);
  }, [occurentContainerRef.current?.clientWidth]);

  useEffect(() => {
    setChunkSize(
      windowWidth > 1400
        ? 10
        : windowWidth > 900
          ? 5
          : windowWidth > 600
            ? 6
            : 5
    );

    if (allItems) {
      const chunkedArray = chunkArray(allItems);
      setRecentSurveyItems([...chunkedArray]);
    }
  }, [windowWidth]);

  useEffect(() => {
    const handleResizePage = () => {
      setWidnowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResizePage);
    return () => window.removeEventListener('resize', handleResizePage);
  }, []);

  const currentDate = new Date().getTime();
  const formattedCurrentDate = moment(new Date(currentDate)).format(
    CURRENT_DATE_FORMAT
  );

  useEffect(() => {
    if (recentSurveyItems?.length) {
      sliderRef.current?.slickGoTo(recentSurveyItems.length - 1);
    }
  }, [recentSurveyItems]);

  useEffect(() => {
    const seenTourOptions = state.thisUser.userFlags?.['tour']?.reduce(
      (acc: string[], flag) => [...acc, flag.flagName],
      []
    );
    const filteredTourList = componentTour.filter(
      (tour) => !seenTourOptions?.includes(tour.category)
    );
    if (filteredTourList && thisUser.userId)
      addTourStep(setSteps, filteredTourList);
  }, []);

  const tomorrow = moment(new Date(currentDate + TOMMOROW_GAP)).format(
    CURRENT_DATE_FORMAT
  );

  const dayAfterTomorrow = moment(
    new Date(currentDate + DAY_AFTER_TOMORROW_GAP)
  ).format(CURRENT_DATE_FORMAT);

  const allTasks =
    selectedTemplateId === 'all'
      ? assigneedTasks
      : assigneedTasks?.filter(
          (task) => task.templateId === selectedTemplateId
        );

  const groupedTasks =
    allTasks?.reduce((acc: { [key: string]: number[] }, task: ITask) => {
      const taskStartDate = moment(
        task.startDate || task.creationDate - 1000000
      ).format(CURRENT_DATE_FORMAT);
      const taskDueDate = moment(
        task.dueDate || task.creationDate - 1000000
      ).format(CURRENT_DATE_FORMAT);

      if (
        taskStartDate === formattedCurrentDate ||
        taskDueDate === formattedCurrentDate
      ) {
        acc['today'] = [...(acc['today'] || []), task.id];
      } else if (taskStartDate === tomorrow || taskDueDate === tomorrow) {
        acc['tomorrow'] = [...(acc['tomorrow'] || []), task.id];
      } else if (
        taskStartDate === dayAfterTomorrow ||
        taskDueDate === dayAfterTomorrow
      ) {
        acc['dayAfterTomorrow'] = [...(acc['dayAfterTomorrow'] || []), task.id];
      } else if (
        moment(
          Math.max(task.startDate || 0, task.dueDate || 0) ||
            task.creationDate - 1000_000_000
        ).format(CURRENT_DATE_FORMAT) < formattedCurrentDate
      ) {
        acc['previous'] = [...(acc['previous'] || []), task.id];
      } else {
        acc['future'] = [...(acc['future'] || []), task.id];
      }
      return acc;
    }, {}) || {};

  return (
    <HomePageContainer>
      {/* <SurveyFormModal
        isOpen={surveyModalIsOpen}
        onClose={handleCloseSurveyModal}
        onDismiss={() => handleDismissSurveyModal()}
        targetSurveyURL="https://app.rastech.ir/content/2/direct/331515"
        title={t('PDPSurvey')}
      /> */}
      <TaskSummeryContainer>
        <TaskMentionContainer companyId={companyId!} company={company} />
        <CategorizedTasksContainer className={'companyHomepage-taskList'}>
          <SectionTitle>{t('occurrentTask')}</SectionTitle>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '1rem',
              width: '300px',
              margin: 'auto',
            }}
          >
            <ButtonGroup
              items={{
                all: `${t('all')} (${convertDigitToProperFormat(assigneedTasks.length)})`,
                incomplete: `${t('incompleteSmall', { ns: 'taskManager' })} (${convertDigitToProperFormat(assigneedTasks.filter((task) => task.assignee[state.thisUser.userId]?.status !== 'complete').length)})`,
              }}
              onSelect={(filter) =>
                setTaskFilter(filter as 'all' | 'incomplete')
              }
              selected={taskFilter}
              border={false}
            />
          </div>
          {/*<TemplateSelectorContainer>
            {company && (
              <TemplateSelectorList
                projects={company.projects as TProjects}
                tasks={state.tasks.data}
                company={company}
                onSelect={handleChangeTemplate}
                selectedTemplate={selectedTemplateId}
                isShowSummery={true}
              />
            )}
          </TemplateSelectorContainer>*/}
          <TaskListViewContainer ref={occurentContainerRef}>
            {loading[1] === 'fetching' ? (
              <LoadingCircleIndicator />
            ) : Object.keys(groupedTasks || {}).length === 0 ? (
              <div className="h-full flex justify-center items-center">
                <div
                  className="font-bold flex align-center justify-center"
                  style={{ margin: 'auto 0', color: black }}
                >
                  {t('nothingFounded')}
                </div>
              </div>
            ) : (
              company &&
              [
                'today',
                'tomorrow',
                'dayAfterTomorrow',
                'future',
                'previous',
              ].map((key) => {
                const value = groupedTasks[key] || [];
                const visibleTasks = value.filter((taskId) => {
                  const task = allTasks?.find((t) => t.id === taskId);
                  return (
                    taskFilter === 'all' ||
                    task?.assignee[state.thisUser.userId]?.status !== 'complete'
                  );
                });
                return (
                  <div key={key}>
                    <DateGroupHeader
                      style={{
                        maxHeight: visibleTasks.length > 0 ? '60px' : '0px',
                        overflow: 'hidden',
                        transition: 'all 0.5s ease-out',
                        opacity: visibleTasks.length > 0 ? '1' : '0',
                      }}
                    >
                      {t(`day-${key}`)}
                    </DateGroupHeader>
                    {value.map((taskId: number, index: number) => {
                      const task = allTasks?.find(
                        (t) => t.id === taskId
                      ) as ITask;
                      const template = state.tasks.data[task.templateId];
                      const isVisible =
                        taskFilter === 'all' ||
                        task?.assignee[state.thisUser.userId]?.status !==
                          'complete';

                      return (
                        <div
                          key={task.id}
                          style={{
                            maxHeight: isVisible ? '200px' : '0px',
                            overflow: 'hidden',
                            transition: 'all 0.5s ease-out',
                            opacity: isVisible ? '1' : '0',
                          }}
                        >
                          <TaskListView
                            index={index}
                            task={task}
                            template={template}
                            thisUser={state.thisUser}
                            companyId={companyId}
                            onClickOnTask={(e: any) =>
                              handleClickOnTask(task, e)
                            }
                            onUpdateTask={handleUpdateTask}
                            companyOwnerId={company?.owner.userId as number}
                            isHomePage={true}
                            sShowSummery={true}
                            i
                            windowSize={
                              occurentContainerWidth < 600 ? 'small' : 'large'
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                );
              })
            )}
          </TaskListViewContainer>
        </CategorizedTasksContainer>
        <RecentlyFilledItemsContainer className={'companyHomepage-slider'}>
          <SectionTitle>{t('recentChecklist')}</SectionTitle>
          <SliderContainer>
            <CustomSlider ref={sliderRef} {...settings}>
              {loading[2] === 'fetching' ? (
                <div>
                  <div
                    className="font-bold flex align-center justify-center"
                    style={{ marginTop: '5rem' }}
                  >
                    <LoadingCircleIndicator />
                  </div>
                </div>
              ) : (recentSurveyItems?.length || 0) > 0 ? (
                recentSurveyItems?.map((surveyItemList, idx) => (
                  <RecentlyFilledItemsList key={idx}>
                    {surveyItemList.map((el) => (
                      <ItemsWrapper
                        key={el.id}
                        onClick={() => {
                          const params = new URLSearchParams(
                            window.location.search
                          );
                          params.set('id', el.id.toString());
                          navigate(
                            `${window.location.pathname}?${params.toString()}`
                          );
                          // cntx.changeOpenItems(el.id, el.providerId);
                        }}
                      >
                        <BadgeContainer
                          type={el.type}
                          color={
                            el.type === 'document'
                              ? blue
                              : el.type === 'folder'
                                ? orange
                                : el.type === 'surveyReport'
                                  ? green
                                  : el.type === 'survey'
                                    ? purple
                                    : red
                          }
                        >
                          <LocalIcon
                            iconName={
                              el.type === 'document'
                                ? 'text.svg'
                                : el.type === 'quill'
                                  ? 'document.svg'
                                  : el.type === 'folder'
                                    ? 'zip.svg'
                                    : el.type === 'survey'
                                      ? 'survey.svg'
                                      : 'link.svg'
                            }
                          />
                        </BadgeContainer>
                        <ContentContainer>
                          <div
                            style={{
                              position: 'relative',
                              top: '0',
                              overflow: 'hidden',
                              textAlign: 'center',
                            }}
                          >
                            {el.name || el.formatedName}
                          </div>
                        </ContentContainer>
                      </ItemsWrapper>
                    ))}
                  </RecentlyFilledItemsList>
                ))
              ) : (
                <div>
                  <div
                    className="font-bold flex align-center justify-center"
                    style={{ marginTop: '10rem', color: black }}
                  >
                    {t('nothingFounded')}
                  </div>
                </div>
              )}
            </CustomSlider>
          </SliderContainer>
        </RecentlyFilledItemsContainer>
      </TaskSummeryContainer>

      <TaskStackContainer>{children}</TaskStackContainer>
    </HomePageContainer>
  );
};

export default CompanyHomePage;
